import { useMutation } from "@tanstack/react-query";
import * as yup from "yup";
import { http } from "../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../consts/api";

const requestSchema = yup.object({
  appointmentId: yup.number().required(),
});

export function useResendVirtualInviteMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.get(HTTP_ENDPOINTS.resendVirtialInvite(req.appointmentId));
  }, options);
}
